<section class="faq d-flex flex-column align-items-center" *ngIf="vm" [attr.data-testid]="vm.slug">
  <div class="accordions" data-testid="MarketingLandingPage.faqAccordions">
    <h2 data-testid="MarketingLandingPage.faq">{{ vm.title }}</h2>
    <osn-shared-accordions [vm]="vm.questions"></osn-shared-accordions>
  </div>
</section>
